import { render } from "./KeyboardTool.vue?vue&type=template&id=3b9268c4&scoped=true"
import script from "./KeyboardTool.vue?vue&type=script&lang=js"
export * from "./KeyboardTool.vue?vue&type=script&lang=js"

import "./KeyboardTool.vue?vue&type=style&index=0&id=3b9268c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b9268c4"]])

export default __exports__